// Сгенерировано из fotocard: карта названия (как в БД) -> картинка лица карты.
// Файлы лежат в frontend/public/cards/, рубашка остаётся /assets/tarot-card.webp.
export const CARD_IMAGES={
  'Башня':'/cards/bashnya.webp',
  'Четвёрка Кубков':'/cards/chetvyorka-kubkov.webp',
  'Четвёрка Мечей':'/cards/chetvyorka-mechej.webp',
  'Четвёрка Пентаклей':'/cards/chetvyorka-pentaklej.webp',
  'Четвёрка Жезлов':'/cards/chetvyorka-zhezlov.webp',
  'Десятка Кубков':'/cards/desyatka-kubkov.webp',
  'Десятка Мечей':'/cards/desyatka-mechej.webp',
  'Десятка Пентаклей':'/cards/desyatka-pentaklej.webp',
  'Десятка Жезлов':'/cards/desyatka-zhezlov.webp',
  'Девятка Кубков':'/cards/devyatka-kubkov.webp',
  'Девятка Мечей':'/cards/devyatka-mechej.webp',
  'Девятка Пентаклей':'/cards/devyatka-pentaklej.webp',
  'Девятка Жезлов':'/cards/devyatka-zhezlov.webp',
  'Двойка Кубков':'/cards/dvojka-kubkov.webp',
  'Двойка Мечей':'/cards/dvojka-mechej.webp',
  'Двойка Пентаклей':'/cards/dvojka-pentaklej.webp',
  'Двойка Жезлов':'/cards/dvojka-zhezlov.webp',
  'Дьявол':'/cards/dyavol.webp',
  'Иерофант':'/cards/ierofant.webp',
  'Император':'/cards/imperator.webp',
  'Императрица':'/cards/imperatritsa.webp',
  'Колесница':'/cards/kolesnitsa.webp',
  'Колесо Фортуны':'/cards/koleso-fortuny.webp',
  'Король Кубков':'/cards/korol-kubkov.webp',
  'Король Мечей':'/cards/korol-mechej.webp',
  'Король Пентаклей':'/cards/korol-pentaklej.webp',
  'Король Жезлов':'/cards/korol-zhezlov.webp',
  'Королева Кубков':'/cards/koroleva-kubkov.webp',
  'Королева Мечей':'/cards/koroleva-mechej.webp',
  'Королева Пентаклей':'/cards/koroleva-pentaklej.webp',
  'Королева Жезлов':'/cards/koroleva-zhezlov.webp',
  'Луна':'/cards/luna.webp',
  'Маг':'/cards/mag.webp',
  'Мир':'/cards/mir.webp',
  'Отшельник':'/cards/otshelnik.webp',
  'Паж Кубков':'/cards/pazh-kubkov.webp',
  'Паж Мечей':'/cards/pazh-mechej.webp',
  'Паж Пентаклей':'/cards/pazh-pentaklej.webp',
  'Паж Жезлов':'/cards/pazh-zhezlov.webp',
  'Повешенный':'/cards/poveshennyj.webp',
  'Пятёрка Кубков':'/cards/pyatyorka-kubkov.webp',
  'Пятёрка Мечей':'/cards/pyatyorka-mechej.webp',
  'Пятёрка Пентаклей':'/cards/pyatyorka-pentaklej.webp',
  'Пятёрка Жезлов':'/cards/pyatyorka-zhezlov.webp',
  'Рыцарь Кубков':'/cards/rytsar-kubkov.webp',
  'Рыцарь Мечей':'/cards/rytsar-mechej.webp',
  'Рыцарь Пентаклей':'/cards/rytsar-pentaklej.webp',
  'Рыцарь Жезлов':'/cards/rytsar-zhezlov.webp',
  'Семёрка Кубков':'/cards/semyorka-kubkov.webp',
  'Семёрка Мечей':'/cards/semyorka-mechej.webp',
  'Семёрка Пентаклей':'/cards/semyorka-pentaklej.webp',
  'Семёрка Жезлов':'/cards/semyorka-zhezlov.webp',
  'Шестёрка Кубков':'/cards/shestyorka-kubkov.webp',
  'Шестёрка Мечей':'/cards/shestyorka-mechej.webp',
  'Шестёрка Пентаклей':'/cards/shestyorka-pentaklej.webp',
  'Шестёрка Жезлов':'/cards/shestyorka-zhezlov.webp',
  'Шут':'/cards/shut.webp',
  'Сила':'/cards/sila.webp',
  'Смерть':'/cards/smert.webp',
  'Солнце':'/cards/solntse.webp',
  'Справедливость':'/cards/spravedlivost.webp',
  'Суд':'/cards/sud.webp',
  'Тройка Кубков':'/cards/trojka-kubkov.webp',
  'Тройка Мечей':'/cards/trojka-mechej.webp',
  'Тройка Пентаклей':'/cards/trojka-pentaklej.webp',
  'Тройка Жезлов':'/cards/trojka-zhezlov.webp',
  'Туз Кубков':'/cards/tuz-kubkov.webp',
  'Туз Мечей':'/cards/tuz-mechej.webp',
  'Туз Пентаклей':'/cards/tuz-pentaklej.webp',
  'Туз Жезлов':'/cards/tuz-zhezlov.webp',
  'Умеренность':'/cards/umerennost.webp',
  'Верховная Жрица':'/cards/verhovnaya-zhritsa.webp',
  'Влюблённые':'/cards/vlyublyonnye.webp',
  'Восьмёрка Кубков':'/cards/vosmyorka-kubkov.webp',
  'Восьмёрка Мечей':'/cards/vosmyorka-mechej.webp',
  'Восьмёрка Пентаклей':'/cards/vosmyorka-pentaklej.webp',
  'Восьмёрка Жезлов':'/cards/vosmyorka-zhezlov.webp',
  'Звезда':'/cards/zvezda.webp',
}
